import type { Category } from '@klopotun/contracts';
import type { CategoryBodyDraft, CategoryFormValues } from '../model/category-form-values.js';

const emptyToNull = (value: string): string | null => {
  const trimmed = value.trim();

  return trimmed === '' ? null : trimmed;
};

/**
 * `sortOrder` has no field of its own: a new category goes to the end of the list and an edited one
 * keeps the place it had. It still travels through the form because PATCH carries the whole body,
 * and a missing value would reshuffle the list on every save.
 */
export const emptyCategoryFormValues = (sortOrder: number): CategoryFormValues => ({
  name: '',
  emoji: '',
  color: '',
  sortOrder,
});

export const toCategoryFormValues = (category: Category): CategoryFormValues => ({
  name: category.name,
  emoji: category.emoji ?? '',
  color: category.color ?? '',
  sortOrder: category.sortOrder,
});

export const toCategoryBodyDraft = (values: CategoryFormValues): CategoryBodyDraft => ({
  name: values.name.trim(),
  emoji: emptyToNull(values.emoji),
  color: emptyToNull(values.color),
  sortOrder: values.sortOrder,
});
